import { CheckCircleOutlined, HistoryOutlined } from "@ant-design/icons";
import { HRD_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "home",
    path: `${HRD_PREFIX_PATH}/approval-pinjaman`,
    title: "Approval Pinjaman",
    icon: CheckCircleOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "riwayat-pencairan",
    path: `${HRD_PREFIX_PATH}/riwayat-pencairan`,
    title: "Riwayat Pencairan",
    icon: HistoryOutlined,
    breadcrumb: false,
    submenu: [],
  },
  // {
  //   key: "master-karyawan",
  //   path: `${HRD_PREFIX_PATH}/karyawan`,
  //   title: "Karyawan",
  //   icon: DatabaseOutlined,
  //   breadcrumb: false,
  //   submenu: [],
  // },
  // {
  //   key: "master-plafond",
  //   path: `${HRD_PREFIX_PATH}/plafond`,
  //   title: "Plafond",
  //   icon: DatabaseOutlined,
  //   breadcrumb: false,
  //   submenu: [],
  // },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
